import { render, staticRenderFns } from "./ModalRejection.vue?vue&type=template&id=980aaa10&"
import script from "./ModalRejection.vue?vue&type=script&lang=js&"
export * from "./ModalRejection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports